(() => {
  if (window.__lmcdOfferVideoCarouselScript) return;
  window.__lmcdOfferVideoCarouselScript = true;

  const initialize = (root) => {
    if (root.dataset.offerVideoReady === 'true') return;
    const cards = [...root.querySelectorAll('[data-offer-video-card]')];
    if (!cards.length) return;
    root.dataset.offerVideoReady = 'true';
    const track = root.querySelector('[data-offer-video-track]');
    const progress = root.querySelector('[data-offer-video-progress]');
    const videos = cards.map((card) => card.querySelector('video'));
    const playButtons = cards.map((card) => card.querySelector('[data-offer-video-play]'));
    const cleanup = [];
    const listen = (node, event, handler) => {
      if (!node) return;
      node.addEventListener(event, handler);
      cleanup.push(() => node.removeEventListener(event, handler));
    };
    let current = 0;

    const select = (index, moveTrack = true) => {
      current = (index + cards.length) % cards.length;
      cards.forEach((card, cardIndex) => {
        card.setAttribute('aria-current', cardIndex === current ? 'true' : 'false');
        if (cardIndex === current) return;
        const video = videos[cardIndex];
        video.pause();
        video.muted = true;
        video.controls = false;
        playButtons[cardIndex].hidden = false;
      });
      if (progress) progress.textContent = `${current + 1} / ${cards.length}`;
      if (moveTrack) track?.scrollTo({left: cards[current].offsetLeft - cards[0].offsetLeft, behavior: 'instant'});
    };

    const playWithSound = (index) => {
      select(index);
      const video = videos[index];
      const button = playButtons[index];
      video.muted = false;
      video.controls = true;
      button.hidden = true;
      const attempt = video.play();
      attempt?.catch?.(() => {
        video.muted = true;
        video.controls = false;
        button.hidden = false;
        button.textContent = 'Tap to retry';
      });
    };

    listen(root.querySelector('[data-offer-video-prev]'), 'click', () => select(current - 1));
    listen(root.querySelector('[data-offer-video-next]'), 'click', () => select(current + 1));
    listen(track, 'scroll', () => {
      const viewportCenter = track.scrollLeft + track.clientWidth / 2;
      let closest = current;
      let distance = Infinity;
      cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft - cards[0].offsetLeft + card.offsetWidth / 2;
        const nextDistance = Math.abs(cardCenter - viewportCenter);
        if (nextDistance < distance) { distance = nextDistance; closest = index; }
      });
      if (closest !== current) select(closest, false);
    });
    cards.forEach((card, index) => {
      const video = videos[index];
      const button = playButtons[index];
      listen(button, 'click', () => playWithSound(index));
      listen(video, 'click', () => { if (!video.controls) playWithSound(index); });
      listen(video, 'pause', () => { if (index === current) button.hidden = false; });
      listen(video, 'play', () => { button.hidden = true; });
      listen(video, 'error', () => {
        button.hidden = false;
        button.textContent = 'Video unavailable';
        button.disabled = true;
      });
    });

    root.__offerVideoTeardown = () => {
      cleanup.splice(0).forEach((remove) => remove());
      videos.forEach((video) => { video.pause(); video.muted = true; video.controls = false; });
      delete root.dataset.offerVideoReady;
      delete root.__offerVideoTeardown;
    };
  };

  const boot = () => document.querySelectorAll('[data-offer-video-carousel]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', ({target}) => {
    if (target.matches?.('[data-offer-video-carousel]')) target.__offerVideoTeardown?.();
    target.querySelectorAll?.('[data-offer-video-carousel]').forEach((root) => root.__offerVideoTeardown?.());
  });
})();
